import { c as _c } from "react/compiler-runtime";
import { EnterpriseInstanceLookup } from "@/components/EnterpriseInstanceLookup";
import FadeIn from "@/components/FadeIn";
import { WorkOSLoginCard } from "./WorkOSLoginCard";
export function WorkOSLoginPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col items-center justify-center min-h-screen bg-app-background"><FadeIn><EnterpriseInstanceLookup><WorkOSLoginCard /></EnterpriseInstanceLookup></FadeIn></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}